import { render, staticRenderFns } from "./view_Event.vue?vue&type=template&id=4c3f5ddc&scoped=true"
import script from "./view_Event.vue?vue&type=script&lang=js"
export * from "./view_Event.vue?vue&type=script&lang=js"
import style0 from "./view_Event.vue?vue&type=style&index=0&id=4c3f5ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f5ddc",
  null
  
)

export default component.exports